import { Locale } from '@nx-ahs/base-translate';

export const locale: Locale = {
	lang: 'en',
	data: {
		ACCOUNT_INFORMATION: 'Account Information',
		ADD_MEMBER: 'Add Member',
		ALL: 'All',
		AT: ' - ',
		CANCEL: 'CANCEL',
		CANNOT_REPLY: 'This message is marked as closed and cannot be replied to.',
		CLEAR: 'Clear',
		CLOSE: 'Close',
		CLOSED: 'Closed',
		CLOSE_TASK_MESSAGE_WARNING: 'Are you sure you want to mark this message as closed?',
		CONTACT_CENTER: 'Help Desk',
		CONTACT_INFO_CHANGE: 'Contact Information Change',
		CONTACT_PREFERENCE: 'I would prefer to be contacted by:',
		CONTACT_PREFERENCE_ERROR: 'Please choose a contact preference',
		CONVERSATION: 'Conversation',
		COVERAGE_QUESTION: 'Coverage Question',
		DATE: 'Date',
		DESCRIPTION:
			'Need help? Send us a message and we will respond within 8 business hours. To talk with us, please call 1-888-540-KIDS (5437) weekdays between 7:30 AM and 7:30 PM, Eastern Time.',
		ENTER_PHONE: '0000000000',
		FILTER_ON_MESSAGE_STATUS: 'Filter on message status:',
		LAST_MESSAGE_RECIEVED: 'Last Message Received On',
		MARK_OPEN: 'Mark as Open',
		MARK_CLOSED: 'Mark Closed?',
		MARKED_CLOSED_BY: 'Marked closed by ',
		MESSAGE: 'Message',
		MESSAGE_ERROR: 'Please enter a message',
		MESSAGE_STATUS: 'Message Status',
		NEW_MESSAGE: 'New Message',
		NEW_SECURE_MESSAGE: 'New Message',
		OPEN: 'Open',
		OTHER: 'Other',
		PAYMENT_PORTAL: 'Premium Portal',
		PLAN_QUESTION: 'Plan Question',
		PREFERRED_CONTACT_TIME: 'Preferred time of day',
		PROVIDER_QUESTION: 'Provider Question',
		CONVERSATION_PHONE: 'Phone Number',
		PHONENUMBER_ERROR: 'Please enter a phone number',
		PHONENUMBER_LABEL: 'Please enter a phone number',
		RECURRING_PAYMENTS: 'Recurring Payments',
		PREMIUM_AMOUNT: 'Premium Amount',
		REGARDING: 'That applies to the following member:',
		REGARDING_ERROR: 'Please choose a member',
		SEARCH_MESSAGES: 'Search Messages',
		SELECT_ANY: 'Select Any',
		SELECT_A_MEMBER: 'Select a Member',
		SEND: 'SEND',
		SERVICE_QUESTION: 'Service Question',
		STATUS: 'Status',
		SUBJECT: 'I have a question or concern about:',
		SUBJECT_ERROR: 'Please choose a subject',
		TITLE: 'Messaging',
		TO_START_NEW_MESSAGE: 'To start a new message click',
		TYPE_MESSAGE_HERE: 'Please type your message here',
		VIEW_MESSAGES: 'Message',
		SecureMessage: 'Secure Message',
		Call: 'Call',
		Other: 'Other',
		EligibilityCoverage: 'Eligibility / Coverage',
		EnrollmentPlanChange: 'Enrollment / Plan Change',
		IDCards: 'ID Cards',
		Medicare: 'Medicare',
		Payment: 'Payment',
		PersonalInformation: 'Personal Information',
		Services: 'Services',
		YES: 'YES',
		NO: 'NO',
		REOPEN: 'Reopen',
		STATUS_CHANGED_TO: 'Status changed to '
	}
};
